import React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import Container from 'src/Result/Container'
import { SortedServer } from 'src/lib/ookla_speed_test'

export type ResultData = {
  download: number
  upload: number
  ping: number
  sortedServer: SortedServer
  clientIP: string
  guid: string
  timeStamp?: number
}

const Result = (props: RouteComponentProps) => {
  return <Container props={props} />
}

export default Result
